module.exports = __webpack_public_path__ + "img/EliteEducation.86ef2842.jpg";